/*
 * DC jQuery Social Stream
 * Copyright (c) 2012 Design Chemical
 * http://www.designchemical.com/blog/index.php/premium-jquery-plugins/jquery-social-stream-plugin/
 * Version 1.1 (14-04-2012)
 *
 */
 
(function($){

	SocialStreamObject = function(el, options) {
		this.create(el, options);
	};
	
	$.extend(SocialStreamObject.prototype, {
		
		version   : '1.0',
		
		create: function(el, options) {
		
			this.defaults = {
				feeds: {
					facebook: {
						id: '',
						intro: 'Posted to wall',
						out: 'intro,thumb,title',
						icon: 'facebook.png'
					},
					twitter: {
						id: '',
						intro: 'Tweeted',
						out: 'intro,date,text,user',
						icon: 'twitter.png'
					},
					google: {
						id: '',
						intro: 'Shared',
						out: 'intro,thumb,title,text',
						api_key: 'AIzaSyB1UZNnscjMDjjH-pi_XbnLRld2wAqi3Ek',
						shares: true,
						icon: 'google.png'
					},
					youtube: {
						id: '',
						intro: 'Uploaded,Favorite,New Video',
						out: 'intro,thumb,title,text,user',
						feed: 'uploads,favorites,newsubscriptionvideos',
						icon: 'youtube.png'
					},
					flickr: {
						id: '',
						intro: 'Uploaded',
						out: 'intro,thumb,title,text',
						lang: 'en-us',
						icon: 'flickr.png'
					},
					delicious: {
						id: '',
						intro: 'Bookmarked',
						out: 'intro,thumb,title,text,user',
						icon: 'delicious.png'
					},
					pinterest: {
						id: '',
						intro: 'Pinned',
						out: 'intro,thumb,title,text,user',
						icon: 'pinterest.png'
					},
					rss: {
						id: '',
						intro: 'Posted',
						out: 'intro,title,text',
						icon: 'rss.png'
					},
					lastfm: {
						id: '',
						intro: 'Listened to,Loved,Replied',
						out: 'intro,thumb,title,text,user',
						feed: 'recenttracks,lovedtracks,replytracker',
						icon: 'lastfm.png'
					},
					dribbble: {
						id: '',
						intro: 'Posted shot,Liked',
						out: 'intro,thumb,title,text,user',
						feed: 'shots,likes',
						icon: 'dribbble.png'
					},
					vimeo: {
						id: '',
						intro: 'Liked,Video,Appeared In,Video,Album,Channel,Group',
						out: 'intro,thumb,title,text,user',
						feed: 'likes,videos,appears_in,all_videos,albums,channels,groups',
						thumb: 'medium',
						stats: true,
						icon: 'vimeo.png'
					},
					stumbleupon: {
						id: '',
						intro: 'Shared,Reviewed',
						out: 'intro,thumb,title,text,user',
						feed: 'favorites,reviews',
						icon: 'stumbleupon.png'
					},
					deviantart: {
						id: '',
						intro: 'Deviation',
						out: 'intro,thumb,title,text,user',
						icon: 'deviantart.png'
					}
				},
				days: 10,
				limit: 50,
				max: 'days',
				external: true,
				speed: 600,
				height: 550,
				wall: false,
				filter: true,
				controls: true,
				rotate: {
					direction: 'up',
					delay: 8000
				},
				cache: true,
				container: 'dcsns',
				cstream: 'stream',
				content: 'dcsns-content',
				iconPath: '',
				imagePath: '',
				debug: false
			};
			
			this.o = {}, this.timer_on = 0, this.id = 'dcsns-'+$(el).index(), this.timerId = '', this.o = $.extend(true,this.defaults,options), opt = this.o, $load = $('<div class="dcsns-loading">creating stream ...</div>');
			
			$(el).addClass(this.o.container).append('<div class="'+this.o.content+'"><ul class="'+this.o.cstream+'"></ul></div>');
			
			var $c = $('.'+this.o.content,el), $a = $('.'+this.o.cstream,el), $l = $('li',$a);

			if(opt.height > 0 && opt.wall == false){
				$c.css({height:opt.height+'px'});
			}

			if(this.o.filter == true || this.o.controls == true){
				var x = '<div class="dcsns-toolbar">';
				if(this.o.filter == true){
					x += '<ul id="dcsns-filter" class="option-set filter">';
					x += this.o.wall == true ? '<li><a href="#filter" data-group="dc-filter"  data-filter="*" class="selected link-all">all</a></li>' : '' ;
					var $f = $('.filter',el);
					$.each(opt.feeds, function(k,v){
						x += v.id != '' ? '<li class="active f-'+k+'"><a href="#filter" rel="'+k+'" data-group="dc-filter" data-filter=".dcsns-'+k+'"><img src="'+opt.imagePath+opt.feeds[k].icon+'" alt="" /></a></li>' : '' ;
					});
					x += '</ul>';
				}
				if(this.o.controls == true && opt.wall == false){
					var play = this.o.rotate.delay <= 0 ? '' : '<li><a href="#" class="play"></a></li>' ;
					x += '<div class="controls"><ul>'+play+'<li><a href="#" class="prev"></a></li><li><a href="#" class="next"></a></li></ul></div>';
				}
				x += '</div>';
				if(opt.wall == false){
					$(el).append(x);
				} else {
					$(el).before(x);
				}
			}
			
			if(this.o.wall == true){
				$('.dcsns-toolbar').append($load);
				this.createwall($a);
			} else {
				$c.append($load);
			}
			
			this.createstream(el,$a,0,opt.days);
			
			this.addevents(el,$a);
			
			if(this.o.rotate.delay > 0){
				this.rotate(el);
			}
			
			$load.remove();
		},
		
		createstream: function(obj,s,f1,f2){
			$.each(opt.feeds, function(k,v){
				if(opt.feeds[k].id != ''){
					var txt = [];
					$.each(opt.feeds[k].intro.split(','), function(i,v){
						txt.push(v);
					});
					$.each(opt.feeds[k].id.split(','), function(i,v){
						if(opt.feeds[k].feed){
							$.each(opt.feeds[k].feed.split(','), function(i,feed){
								getFeed(k,v,opt.iconPath,opt.feeds[k],obj,opt,f1,f2,txt[i],feed);
							});
						} else {
							getFeed(k,v,opt.iconPath,opt.feeds[k],obj,opt,f1,f2,opt.feeds[k].intro,'');
						}
					});
				}
			});
		},
		
		createwall: function(obj){
			obj.imagesLoaded( function(){
				obj.isotope({
					itemSelector : 'li',
					getSortData : {
						postDate : function( $elem ){
							return parseInt($elem.attr('rel'),10);
						}
					},
					sortBy : 'postDate'
				});
			});
		},
		
		addevents: function(obj,$a){
			var self = this, speed = this.o.speed;
			var $container = $('.stream',obj), filters = {}
			$('.controls',obj).delegate('a','click',function(){
				var x = $(this).attr('class');
				switch(x)
				{
					case 'prev':
					self.pauseTimer();
					ticker($a,'prev',speed);
					break;
					case 'next':
					self.pauseTimer();
					ticker($a,'next',speed);
					break;
					case 'play':
					self.rotate(obj);
					$('.controls .play').removeClass('play').addClass('pause');
					break;
					case 'pause':
					self.pauseTimer();
					break;
				}
				return false;
			});
			$('.filter',obj).delegate('a','click',function(){
				if(opt.wall == false){
					var rel = $(this).attr('rel');
					if($(this).parent().hasClass('active')){
						$('.dcsns-'+rel,$a).slideUp().addClass('inactive');
						$(this).parent().animate({opacity: 0.3},400);
					} else {
						$('.dcsns-'+rel,$a).slideDown().removeClass('inactive');
						$(this).parent().animate({opacity: 1},400);
					}
					$(this).parent().toggleClass('active');
				}
				return false;
			});
			if(this.o.external){
				$a.delegate('a','click',function(){
					this.target = '_blank';
				});
			}
		},
		rotate: function(a){
			var self = this, stream = $('.'+this.o.cstream,a), speed = this.o.speed, delay = this.o.rotate.delay, r = this.o.rotate.direction == 'up' ? 'prev' : 'next' ;
			this.timer_on = 1;
			$('.controls .play').removeClass('play').addClass('pause');
			this.timerId = setTimeout(function(){
				ticker(stream,r,speed);
				self.rotate(a);
			}, delay);
		},
		pauseTimer: function(){
			clearTimeout(this.timerId);
			this.timer_on = 0;
			$('.controls .pause').removeClass('pause').addClass('play');
		}
	});
	
	$.fn.dcSocialStream = function(options, callback){
		var d = {};
		this.each(function(){
			var s = $(this);
			d = s.data("socialtabs");
			if (!d){
				d = new SocialStreamObject(this, options, callback);
				s.data("socialtabs", d);
			}
		});
		return d;
	};
	
	function getFeed(type,id,path,o,obj,opt,f1,f2,intro,feed){
	
		var stream = $('.stream',obj), list = [],d = '', px = 300, c = [],data, href, url, n = opt.limit, txt = [];
		frl = 'http://ajax.googleapis.com/ajax/services/feed/load?v=1.0&num='+n+'&callback=?&q=';
		
		switch (type) {
			
			case 'facebook':
			href = 'http://www.facebook.com/pages/'+id;
			url = 'http://www.facebook.com/feeds/page.php?id='+id+'&format=rss20';
			url = frl + encodeURIComponent(url);
			break;
			
			case 'twitter':
			href = 'http://www.twitter.com/'+id;
			url = 'http://api.twitter.com/1/statuses/user_timeline.json?screen_name='+id+'&count=10&callback=?';
			break;
			
			case 'google': 
			href = 'https://plus.google.com/'+id;
			url = 'https://www.googleapis.com/plus/v1/people/'+id+'/activities/public';
			data = {
				key: o.api_key,
				maxResults: n,
				prettyprint: false,
				fields: "items(id,kind,object(attachments(displayName,fullImage,id,image,objectType,url),id,objectType,plusoners,replies,resharers,url),published,title,url,verb)"
			};
			break;
			
			case 'youtube': 
			href = 'http://www.youtube.com/user/'+id;
			url = 'http://gdata.youtube.com/feeds/base/users/'+id+'/'+feed+'?alt=rss&v=2&orderby=published&client=ytapi-youtube-profile';
			url = frl + encodeURIComponent(url);
			break;
			
			case 'flickr':
			href = 'http://www.flickr.com/photos/'+id;
			url = 'http://api.flickr.com/services/feeds/photos_public.gne?id='+id+'&lang='+o.lang+'&format=json&jsoncallback=?';
			break;
			
			case 'delicious':
			href = 'http://www.delicious.com/'+id;
			url = 'http://feeds.delicious.com/v2/json/'+id;
			break;
			
			case 'pinterest':
			href = 'http://www.pinterest.com/'+id;
			url = frl + encodeURIComponent('http://www.pinterest.com/'+id+'/feed.rss');
			break;
			
			case 'rss':
			href = id;
			url = frl + encodeURIComponent(id);
			break;
			
			case 'lastfm':
			href = 'http://www.last.fm/user/'+id;
			url = frl + encodeURIComponent('http://ws.audioscrobbler.com/1.0/user/'+id+'/'+feed+'.rss');
			break;
			
			case 'dribbble':
			href = 'http://www.dribbble.com/'+id;
			url = feed == 'likes' ? 'http://api.dribbble.com/players/'+id+'/shots/likes' : 'http://api.dribbble.com/players/'+id+'/shots' ;
			break;
			
			case 'vimeo':
			href = 'http://www.vimeo.com/'+id;
			url = 'http://vimeo.com/api/v2/'+id+'/'+feed+'.json';
			break;
			
			case 'stumbleupon':
			href = 'http://www.stumbleupon.com/stumbler/'+id;
			url = frl + encodeURIComponent('http://rss.stumbleupon.com/user/'+id+'/'+feed);
			break;
			
			case 'deviantart':
			href = 'http://'+id+'.deviantart.com';
			url = frl + encodeURIComponent('http://backend.deviantart.com/rss.xml?type=deviation&q=by%3A'+id+'+sort%3Atime+meta%3Aall');
			break;
		}
		
		jQuery.ajax({
			url: url,
			data: data,
			cache: opt.cache,
			dataType: 'jsonp',
			success: function(a){
				var error = '';
				if (type == 'google'){
					if (a.error){
						error = a.error;
					}
					a = a.items;
				} else if (type == 'delicious' || type == 'vimeo'){
				} else if (type == 'flickr'){
					a = a.items;
				} else if (type == 'twitter'){
					if(a.error){
						error = a.error;
					}
				} else if (type == 'dribbble'){
					a = a.shots;
				} else {
					if(a.responseStatus == 200){
						a = a.responseData.feed.entries;
					} else {
						error = a.responseDetails;
					}
				}
				if(error == ''){
					$.each(a, function(i,item){
						if(i < n){
							var html = [], u='<a href="'+href+'">'+id+'</a>', w='', x='', y='', z='', zz='', q='#', d = item.publishedDate;
							switch(type)
							{
								case 'facebook':
								q = item.link;
								x = '<a href="'+q+'">'+item.title+'</a>';
								var src = item.content.indexOf("img") >= 0 ? $('img',item.content).attr('src') : '' ;
								y = src ? '<a href="'+q+'"><img src="'+src+'" alt="" /></a>' : '' ;
								z = item.content;
								break;
								
								case 'twitter':
								d = parseTwitterDate(item.created_at);
								z = linkify(item.text);
								break;
								
								case 'delicious':
								var d = new Date();
								d = d.setRFC3339(item.dt);
								x = '<a href="'+item.u+'">'+item.d+'</a>';
								z = item.n;
								break;
								
								case 'rss':
								q = item.link;
								x = '<a href="'+q+'">'+item.title+'</a>';
								var src = item.content.indexOf("img") >= 0 ? $('img',item.content).attr('src') : '' ;
								y = src ? '<a href="'+q+'"><img src="'+src+'" alt="" /></a>' : '' ;
								z = item.contentSnippet;
								break;
								
								case 'pinterest':
								q = item.link;
								x = '<a href="'+q+'"></a>';
								var src = $('img',item.content).attr('src');
								y = src ? '<a href="'+q+'"><img src="'+src+'" alt="" /></a>' : '' ;
								z = item.contentSnippet;
								break;
								
								case 'youtube':
								q = item.link;
								x = '<a href="'+q+'">'+item.title+'</a>';
								var v = [];
								v = parseQ(item.link);
								y = '<a href="' + q + '"><img src="http://i.ytimg.com/vi/'+v['v']+'/default.jpg" alt="" /></a>';
								z = item.contentSnippet;
								break;
								
								case 'flickr':
								q = item.link;
								d = '';
								x = '<a href="' + q + '" title="'+ item.title +'"><img src="' + item.media.m + '" alt="" /></a>';
								break;
								
								case 'lastfm':
								q = item.content;
								x = '<a href="'+item.content+'">'+item.title+'</a>';
								break;
								
								case 'dribbble':
								q = item.url;
								d = item.created_at;
								x = '<a href="'+q+'">' + item.title + '</a>';
								y = '<a href="'+q+'"><img src="' + item.image_teaser_url + '" alt="' + item.title + '" /></a>';
								z = '<span class="meta"><span class="views">'+num(item.views_count)+'</span><span class="likes">'+num(item.likes_count)+'</span><span class="comments">'+num(item.comments_count)+'</span></span>';
								break;

								case 'vimeo':
								f = feed, at = item.name, tx = item.description, q = item.url;
								if(f == 'channels'){
									y = item.logo != '' ? '<a href="'+q+'" class="logo"><img src="'+item.logo+'" alt="" width="'+px+'" /></a>' : '' ;
								} else if(f == 'groups'){
									y = '<a href="'+q+'"><img src="'+item.thumbnail+'" alt="" /></a>';
								} else {
									var thumb = 'thumbnail_'+o.thumb, at = item.title, tx = f != 'albums' ? item.duration+' mins' : item.description ;
									y = '<a href="'+item.url+'"><img src="'+item[thumb]+'" alt="" /></a>';
								}
								x = '<a href="'+q+'">'+at+'</a>';
								z = tx;
								if(o.stats == true){
									var m = '';
									m += f == 'albums' || f == 'channels' || f == 'groups' ? '<span class="videos">'+num(item.total_videos)+'</span>' : '' ;
									if(f == 'channels'){
										m += '<span class="users">'+num(item.total_subscribers)+'</span>';
									} else if(f == 'groups'){
										m += '<span class="users">'+num(item.total_members)+'</span>';
									} else if(f != 'albums'){
										m += '<span class="likes">'+num(item.stats_number_of_likes)+'</span><span class="views">'+num(item.stats_number_of_plays)+'</span><span class="comments">'+num(item.stats_number_of_comments)+'</span>';
									}
									z += '<span class="meta">'+m+'</span>';
								}
								var dt = item.upload_date;
								if(f == 'likes'){
									dt = item.liked_on;
								} else if(f == 'albums' || f == 'channels' || f == 'groups'){
									dt = item.created_on;
								}
								var d = new Date();
								d = d.setVimeo(dt);
								break;	
								
								case 'stumbleupon':
								q = item.link;
								x = '<a href="'+q+'">'+item.title+'</a>';
								var src = $('img',item.content).attr('src');
								y = src != '' && feed == 'favorites' ? '<a href="'+q+'"><img src="'+src+'" alt="" /></a>' : '' ;
								z = item.contentSnippet;
								break;
								
								case 'deviantart':
								q = item.link;
								x = '<a href="'+q+'">'+item.title+'</a>';
								var src = $('img',item.content).attr('src');
								y = src ? '<a href="'+q+'"><img src="'+src+'" alt="" /></a>' : '' ;
								z = item.contentSnippet;
								break;
								
								case 'google':
								var g = item.object.replies ? num(item.object.replies.totalItems) : 0, m = item.object.plusoners ? num(item.object.plusoners.totalItems) : 0, p = item.object.resharers ? num(item.object.resharers.totalItems) : 0, dl;
								var d = new Date();
								d = d.setRFC3339(item.published);
								dl = {src: "",imgLink: "",useLink: "",useTitle: ""};
								var k = item.object.attachments;
								if (k) if (k.length){
									for (var l = 0; l < k.length; l++) {
										var h = k[l];
										if (h.image) {
											dl.src = h.image.url;
											dl.imgLink = h.url;
											if (h.fullImage) {
												dl.w = h.fullImage.width || 0;
												dl.h = h.fullImage.height || 0
											}
										}
										if (h.objectType == "article") dl.useLink = h.url;
										if (h.displayName) dl.useTitle = h.displayName
									}
									if (!dl.useLink) dl.useLink = dl.imgLink;
									var img_h = o.image_height ? o.image_height : 75 ;
									var img_w = o.image_width ? o.image_width : 75 ;
									if (dl.src.indexOf("resize_h") >= 0) dl.src = dl.w >= dl.h ? dl.src.replace(/resize_h=\d+/i, "resize_h=" + img_h) : dl.src.replace(/resize_h=\d+/i, "resize_w=" + img_w)
								}
								dl = dl;
								q = dl.useLink;
								y = (dl.src ? (dl.useLink ? '<a href="' + dl.useLink + '">' : '')+'<img src="' + dl.src + '" />'+(dl.useLink ? '</a>' : '') : '');
								var t1 = px/(dl.w/dl.h) < px/3 ? ' class="clear"' : '' ;
								x = (dl.useLink ? '<a href="' + dl.useLink + '"'+t1+'>' : '')+(item.title ? item.title : dl.useTitle)+(dl.useLink ? '</a>' : '');
								if(o.shares){
									z = '<span class="meta"><span class="plusones">+1s '+m+'</span><span class="shares">'+p+'</span><span class="comments">'+g+'</span></span>';
								}
								break;
							}
							
							icon = '<a href="'+href+'"><img src="'+path+o.icon+'" alt="" class="icon" /></a>';

							$.each(o.out.split(','), function(i,v){
								
								zz += v != 'intro' ? '<span class="section-'+v+'">' : '' ;
								switch(v)
								{
									case 'intro':
									zintro = '<span class="section-'+v+'"><a href="'+q+'">'+intro+'</a> '+nicetime(new Date(d).getTime(),0)+'</span>';
									break;
									case 'title':
									zz += x;
									break;
									case 'thumb':
									zz += y;
									break;
									case 'text':
									zz += z;
									break;
									case 'user':
									zz += u;
									break;
								}
								zz += v != 'intro' ? '</span>' : '' ;
							});
							
							var diff = nicetime(new Date(d).getTime(),1);
							var out = '<li rel="'+diff+'" class="dcsns-'+type+'">'+w+'<div class="inner">'+zz+'<span class="clear"></span></div>'+zintro+icon+'</li>';
							if(opt.max == 'days'){
								if(diff <= f2 * 86400 && diff >= f1 * 86400){
									list.push(out);
								} else if(diff > f2 * 86400) {
									return false;
								}
							} else {
								list.push(out);
							}
						}
					});
				} else if(opt.debug == true){
					list.push('<li class="dcsns-error">Error. '+error+'</li>');
				}
			},
			complete: function(){
				if(opt.wall == true){
					var $newItems = $(list.join(''));
					stream.isotope( 'insert', $newItems );

				} else {
					stream.append(list.join(''));
					sortstream(stream,'asc');
				}
			}
		});
		return;
	}

	function linkify(text){
		text = text.replace(
			/((https?\:\/\/)|(www\.))(\S+)(\w{2,4})(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/gi,
			function(url){
				var full_url = !url.match('^https?:\/\/') ? 'http://' + url : url ;
				return '<a href="' + full_url + '">' + url + '</a>';
			}
		);
		return text;
	}

	Date.prototype.setRFC3339 = function(dString){
	   var utcOffset, offsetSplitChar;
	   var offsetMultiplier = 1;
	   var dateTime = dString.split('T');
	   var date = dateTime[0].split('-');
	   var time = dateTime[1].split(':');
	   var offsetField = time[time.length - 1];
	   var offsetString;
	   offsetFieldIdentifier = offsetField.charAt(offsetField.length - 1);
	   if (offsetFieldIdentifier == 'Z') {
		  utcOffset = 0;
		  time[time.length - 1] = offsetField.substr(0, offsetField.length - 2);
	   } else {
		  if (offsetField[offsetField.length - 1].indexOf('+') != -1) {
			 offsetSplitChar = '+';
			 offsetMultiplier = 1;
		  } else {
			 offsetSplitChar = '-';
			 offsetMultiplier = -1;
		  }
		  offsetString = offsetField.split(offsetSplitChar);
		  time[time.length - 1] == offsetString[0];
		  offsetString = offsetString[1].split(':');
		  utcOffset = (offsetString[0] * 60) + offsetString[1];
		  utcOffset = utcOffset * 60 * 1000;
	   }
	   this.setTime(Date.UTC(date[0], date[1] - 1, date[2], time[0], time[1], time[2]) + (utcOffset * offsetMultiplier ));
	   return this;
	};
	
	Date.prototype.setVimeo = function(dString){
	   var utcOffset = 0, offsetSplitChar, offsetMultiplier = 1;
	   var dateTime = dString.split(' ');
	   var date = dateTime[0].split('-');
	   var time = dateTime[1].split(':');
	   this.setTime(Date.UTC(date[0], date[1] - 1, date[2], time[0], time[1], time[2]) + (utcOffset * offsetMultiplier ));
	   return this;
	};

	function parseTwitterDate(a){
		var out = a.replace(/(\+\S+) (.*)/, '$2 $1');
		return out;
	}
	
	function nicetime(a,out){
		var c = a.length > 1 ? a : new Date;
		var d = Math.floor(parseInt((c.getTime() - a) / 1e3),10);
			if(out == 0){
				var chunks = new Array();
					chunks[0] = [60 * 60 * 24 * 365 , 'year'];
					chunks[1] = [60 * 60 * 24 * 30 , 'month'];
					chunks[2] = [60 * 60 * 24 * 7, 'week'];
					chunks[3] = [60 * 60 * 24 , 'day'];
					chunks[4] = [60 * 60 , 'hr'];
					chunks[5] = [60 , 'min'];
					var i = 0;
					var j = chunks.length;
					for (i = 0; i < j; i++) {
						s = chunks[i][0];
						n = chunks[i][1];
						if ((xj = Math.floor(d / s)) != 0)
							break;
					}
					val = xj == 1 ? '1 '+n : xj+' '+n+'s';
					if (i + 1 < j) {
						s2 = chunks[i + 1][0];
						n2 = chunks[i + 1][1];
						if ( ((xj2 = Math.floor((d - (s * xj)) / s2)) != 0) )
							val += (xj2 == 1) ? ' + 1 '+n2 : ' + '+xj2+' '+n2+'s';
					}
					val += ' ago';
					return val;
			} else {
				return d;
			}
        }
		
		function num(a){
            var b = a;
            if (a > 999999) b = Math.floor(a / 1E6) + "M";
            else if (a > 9999) b = Math.floor(a / 1E3) + "K";
            else if (a > 999) b = Math.floor(a / 1E3) + "," + a % 1E3;
            return b
        }
		
		function parseQ(url){
			var v = [], hash, q = url.split('?')[1];
			if(q != undefined){
				q = q.split('&');
				for(var i = 0; i < q.length; i++){
					hash = q[i].split('=');
					v.push(hash[1]);
					v[hash[0]] = hash[1];
				}
			}
			return v;
		}
		
		function sortstream(obj,d){
		
			var $l = $('li',obj);
			$l.sort(function(a, b){
				var keyA = parseInt($(a).attr('rel'),10);
				var keyB = parseInt($(b).attr('rel'),10);
				if(d == 'asc'){
					return (keyA > keyB) ? 1 : 0;
				} else {
					return (keyA < keyB) ? 1 : 0;
				}
			});
			$.each($l, function(index, row){
				obj.append(row);
			});
			$('.dcsns-loading').slideUp().remove();
			return;
		}
		
		function ticker(s,b,speed){
			var $a = $('li:last',s),$b = $('li:first',s),$gx,bh = $b.outerHeight(true);
			if($('li',s).not('.inactive').length > 2){
				if(b == 'next'){
					$gx = $a.clone().hide();
					$b.before($gx);
					$a.remove();
					if($a.hasClass('inactive')){
						ticker(s,b,speed);
					} else {
						$('.inner',$gx).css({opacity: 0});
						$gx.slideDown(speed,'linear',function(){
							$('.inner',this).animate({opacity: 1},speed);
						});
						return;
					}
				} else {
					$gx = $b.clone();
					if($b.hasClass('inactive')){
						$a.after($gx);
						$b.remove();
						ticker(s,b,speed);
					} else {
						$b.animate({marginTop: -bh+'px'},speed,'linear',function(){
							$a.after($gx);
							$b.remove();
						});
						$('.inner',$b).animate({opacity: 0},speed);
					}
				}
			}
		}
			
})(jQuery);